export default __webpack_public_path__ + "static/Signerica_Fat-c8192c5fcf8828146ec3f5df69672670.eot";